import StateStoreBase from "./StateStoreBase.js";
class NotificationStore extends StateStoreBase {
  constructor() {
    super(...arguments);
    this.notification = null;
  }
  clear() {
    this.notification = null;
    this.notifySubscribers();
  }
  get() {
    return this.notification;
  }
  show(message, color) {
    this.notification = { color, message, variant: "top" };
    this.notifySubscribers();
  }
  showBottom(message) {
    this.notification = { message, variant: "bottom" };
    this.notifySubscribers();
  }
}
const notificationStore = new NotificationStore();
export {
  NotificationStore,
  notificationStore as default
};
//# sourceMappingURL=notificationStore.js.map
